// Central site config - contact info, links, and copy constants.
// Fields that require real content are intentionally left blank so
// sections/links can be conditionally hidden until content is provided.

export const SITE = {
  brand: "LAYOR Digital Group",
  tagline: "Bring your leadership in the room. Leave with tools you built and can use tomorrow.",
  primaryHeadline: "Extend Your Leadership Capacity With Practical AI",
  phone: "(813) 344-3188",
  phoneHref: "tel:+18133443188",
  email: "info@layordigitalgroup.com",
  calendly: "https://calendly.com/layor2026",
  linkedin: "", // hide until provided
  location: "Providing Services Worldwide",
};

export const SERVICES = [
  { slug: "ai-leadership-consulting", title: "AI Leadership Consulting",
    short: "AI-readiness assessments, roadmaps, and responsible-use guidance grounded in leadership realities." },
  { slug: "training-workshops", title: "Interactive AI Training & Workshops",
    short: "Hands-on sessions where participants build tools on real leadership responsibilities." },
  { slug: "keynotes-facilitation", title: "Keynotes, Conferences & Facilitation",
    short: "Engaging keynotes and breakouts for districts, associations, chambers, and executive events." },
  { slug: "custom-ai-agents", title: "Custom AI Agents & Super Agents",
    short: "Purpose-built assistants for planning, communication, research, and operations - reviewed by humans." },
  { slug: "workflow-design", title: "Workflow Design & Automation",
    short: "Practical, AI-assisted workflows and templates that reduce administrative burden." },
  { slug: "website-development", title: "Website Design & Development",
    short: "Professional, responsive, accessible websites for organizations, programs, and events." },
  { slug: "presentation-design", title: "PowerPoint & Presentation Design",
    short: "Polished decks for conferences, boards, proposals, training, and community events." },
  { slug: "research-briefs", title: "Research, Analysis & Executive Briefs",
    short: "Decision-ready synthesis, competitive reviews, and executive briefing documents." },
  { slug: "custom-toolkits", title: "Custom Leadership Toolkits",
    short: "Prompt libraries, communication templates, decision protocols, and planning tools." },
];

export const AUDIENCES = [
  { title: "Executive Leaders", body: "CEOs, executive directors, cabinets, and senior leaders responsible for enterprise outcomes." },
  { title: "Corporate & Nonprofit Leaders", body: "Executives, managers, and mission-driven teams balancing complex priorities." },
  { title: "Entrepreneurs & Small Businesses", body: "Owners and operators who need practical AI without extra overhead." },
  { title: "Real Estate & Financial Professionals", body: "Advisors, investors, and firms handling sensitive, high-stakes work." },
  { title: "Associations & Conference Organizers", body: "Program committees seeking substantive AI content leaders can use." },
];

export const HELP_CARDS = [
  { title: "Book a Consultation", to: "/contact", cta: "Schedule a call" },
  { title: "Request a Quote", to: "/quote", cta: "Get a customized quote" },
  { title: "Request Training or a Workshop", to: "/quote?service=Training%20or%20Workshop" },
  { title: "Invite Patricia to Speak", to: "/quote?service=Keynote%20or%20Conference%20Presentation" },
  { title: "Create a PowerPoint Presentation", to: "/quote?service=PowerPoint%20Presentation" },
  { title: "Develop a Pitch Deck", to: "/quote?service=Pitch%20Deck" },
  { title: "Build a Website", to: "/quote?service=Website%20Design%20and%20Development" },
  { title: "Build an AI Agent or Super Agent", to: "/quote?service=AI%20Agent%20or%20Super%20Agent" },
  { title: "Request Consulting or Research Support", to: "/quote?service=AI%20Consulting" },
  { title: "Contact LAYOR Digital Group", to: "/contact" },
];

export const FAQ = [
  { q: "Do I need previous AI experience?",
    a: "No. Our sessions are designed for leaders at any experience level. We begin with the work you already manage, and build capacity from there." },
  { q: "Will AI replace our leaders or employees?",
    a: "No. AI is a practical extension of the leadership capacity you already possess. Human judgment stays at the center of every decision." },
  { q: "What will participants leave with after a workshop?",
    a: "Practical tools they helped build - decision protocols, communication workflows, prompt libraries, planning templates - that they can begin using the next day." },
  { q: "Can training be customized for our organization?",
    a: "Yes. Every engagement is customized by industry, leadership level, audience size, and organizational goals." },
  { q: "Does LAYOR Digital Group work outside education?",
    a: "Yes. We work with corporate, nonprofit, small business, financial, real estate, association, and entrepreneurial leaders." },
  { q: "Can you build a custom AI agent for my business?",
    a: "Yes. We build AI agents and super-agent systems designed for specific roles and workflows, with clear human oversight." },
  { q: "Do you create websites and professional presentations?",
    a: "Yes. We design accessible websites, keynote decks, pitch decks, board presentations, and training materials." },
  { q: "Can Patricia speak at our conference or leadership event?",
    a: "Yes. Request Patricia as a keynote speaker, facilitator, or breakout presenter through our quote form." },
  { q: "How do I begin?",
    a: "Book a consultation or request a quote. We will discuss your goals and recommend the appropriate next steps." },
  { q: "Are consultations available virtually or in person?",
    a: "Both. We deliver virtual and in-person engagements worldwide." },
];
